import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyStatus, HttpResponse } from "@/types";

type PartialCandidacyStatus = Exclude<
  CandidacyStatus,
  CandidacyStatus.REJECTED | CandidacyStatus.COULD_NOT_CONTACT
>;

export function useGetCandidacyPartialCountsByStatus() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "candidacies/partial_counts_by_status",
      currentCompanyId,
      currentJobId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/partial_counts_by_status`;
      const res = await guacHttpClient.get<
        Record<PartialCandidacyStatus, number>,
        HttpResponse<Record<PartialCandidacyStatus, number>>
      >(path);
      return res.data;
    },
    enabled: !!currentCompanyId && !!currentJobId,
  });
}
